import { httpClient } from '../httpClient';
export class SimExchangeDeliveryRepository {
    async getSimExchangeDeliveryHistory() {
        const { data } = await httpClient.get('sim/request/list/fetch');
        return data;
    }
    async getSimExchangeDeliveryStatus() {
        const { data } = await httpClient.get('sim/request/status/fetch');
        return data;
    }
    async requestSimExchangeDelivery(params) {
        const { data } = await httpClient.post('sim/request', JSON.stringify(({
            deliveryCustomerSei: params.deliveryCustomerSei,
            deliveryCustomerMei: params.deliveryCustomerMei,
            deliveryCustomerSeiHiragana: params.deliveryCustomerSeiHiragana,
            deliveryCustomerMeiHiragana: params.deliveryCustomerMeiHiragana,
            deliveryZipcode: params.deliveryZipcode,
            deliveryPrefectureCode: params.deliveryPrefectureCode,
            deliveryCity: params.deliveryCity,
            deliveryStreet: params.deliveryStreet,
            deliveryBuilding: params.deliveryBuilding,
            deliveryTelNo: params.deliveryTelNo
        } = params)));
        return data;
    }
    async requestSimExchangeDeliveryForPremium(params) {
        const { data } = await httpClient.post('sim/request/premium', JSON.stringify(({ simsizeCode: params.simsizeCode } = params)));
        return data;
    }
    async getSimExchangeDeliveryStatusForPremium() {
        const { data } = await httpClient.get('sim/request/premium/status/fetch');
        return data;
    }
}
